import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SubmissionAttachment } from '../../../../models/submissions/submission-attachment';
import { ButtonTypeEnum } from '../../../../ui/buttons/button/button-type.enum';
import { ButtonComponent } from '../../../../ui/buttons/button/button.component';
import { FileListItemComponent, FileListItemAction } from '../../../../ui/file-list-item/file-list-item.component';
import { AttachmentLinkPipe } from '../../../../pipes/attachment-link.pipe';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-submission-additional-file-list',
  templateUrl: './submission-additional-file-list.component.html',
  styleUrls: ['./submission-additional-file-list.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, FileListItemComponent, AttachmentLinkPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmissionAdditionalFileListComponent {
  @Input() files: SubmissionAttachment[] = [];
  @Input() canUploadFiles: boolean = false;
  @Input() currentUserIsOwnerOrApprover: boolean = false;
  @Input() hideAllRemoveButtons: boolean = false;
  @Output() removeFile = new EventEmitter<SubmissionAttachment>();
  @Output() fileUploaded = new EventEmitter<File>();

  public fileUploadedEvent(event: any): void {
    this.fileUploaded.emit(event.target.files[0]);
  }

  public getFileAction(): FileListItemAction {
    return this.hideAllRemoveButtons ? 'download' : 'remove';
  }

  public isFileActionDisabled(): boolean {
    return !this.hideAllRemoveButtons && !this.currentUserIsOwnerOrApprover;
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
